import React, { createContext, useContext, useState, useEffect } from 'react';
import API from '../../network/dashboardAPI';

const PermissionsContext = createContext();

export const PermissionsProvider = ({ children }) => {
  const [permissions, setPermissions] = useState(localStorage.getItem("permission") !== "undefined" ? JSON.parse(localStorage.getItem("permission")) ?? {} : null);
  const admin = localStorage.getItem("admin");

  const fetchPermissions = async () => {
    try {
      API.getUsersPermission()
        .then((res) => res.json())
        .then((res) => {
            if (res.success) {
                setPermissions(res.data?.permission);
                localStorage.setItem("permission", JSON.stringify(res.data?.permission || null));
            } else {
                console.log("Something went wrong!");
            }
        });
    } catch (e) {
      console.log("Error, can not find users", e);
    }
  };

  useEffect(() => {
    if(admin)
      fetchPermissions();
  }, []);

  return (
    <PermissionsContext.Provider value={{ permissions, fetchPermissions }}>
      {children}
    </PermissionsContext.Provider>
  );
};

export const usePermissions = () => {
  return useContext(PermissionsContext);
};
